import { Component } from '@angular/core';
import { AppConfigService } from 'app/shared/services/app-config.service';
import { ScreenService } from 'app/shared/services/screen.service';

@Component({
  selector: 'app-help',
  templateUrl: 'help.component.html',
  styleUrls: ['help.component.scss'],
})
export class HelpComponent {
  isMobileModeObservable = this.screenService.observeIsMobile();

  constructor(
    public appConfig: AppConfigService,
    private screenService: ScreenService
  ) {}
}
